var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-staff.81bd98c2.png","uri@2x": __webpack_public_path__ + "icon-staff.cd2e882e.png","uri@3x": __webpack_public_path__ + "icon-staff.5b60875e.png",
    width: 20,
    height: 16
});